import { FieldErrors, UseFormHandleSubmit, useWatch } from 'react-hook-form'
import { ListType } from './areasList'
import { Button, TextInput } from 'components/common'
import { useMemo, useState } from 'react'

const AreaRow = ({
  field,
  index,
  isEditor,
  control,
  register,
  handleRowSave,
  handleDelete,
  originalData,
  loading,
  errors,
  handleSubmit,
}: {
  field: ListType
  index: number
  isEditor: boolean
  control: any
  register: any
  handleRowSave: (index: number, id: string) => void
  handleDelete: (index: number, id: string) => void
  loading: boolean
  originalData: ListType
  handleSubmit: UseFormHandleSubmit<
    {
      areas: ListType[]
    },
    undefined
  >
  errors: FieldErrors<{ areas: ListType[] }>
}) => {
  const shortCode = useWatch({ control, name: `areas.${index}.shortCode` })
  const fullName = useWatch({ control, name: `areas.${index}.fullName` })

  const [currentIndex, setCurrentIndex] = useState<null | number>(null)
  const isChanged = useMemo(() => {
    return (
      shortCode !== originalData.shortCode || fullName !== originalData.fullName
    )
  }, [shortCode, fullName, originalData.shortCode, originalData.fullName])

  const onSubmit = (index: number, id: string) => {
    handleRowSave(index, id)
    setCurrentIndex(index)
  }
  return (
    <form
      onSubmit={handleSubmit(() => onSubmit(index, field._id))}
      className="mb-2 grid grid-cols-5 gap-4"
    >
      <TextInput
        name={`areas.${index}.shortCode`}
        disabled={!isEditor}
        register={register}
        error={errors?.areas?.[index]?.shortCode?.message}
      />
      <TextInput
        name={`areas.${index}.fullName`}
        disabled={!isEditor}
        register={register}
        error={errors?.areas?.[index]?.fullName?.message}
      />
      <div className="flex items-center text-sm text-gray-700">
        {originalData?.areaLat ?? '—'}
      </div>
      <div className="flex items-center text-sm text-gray-700">
        {originalData?.areaLong ?? '—'}
      </div>
      <div className="flex max-h-[42px] items-stretch gap-5">
        <Button
          className="w-full"
          type="submit"
          disabled={!isEditor || !isChanged}
          buttonText="Save"
          loading={currentIndex === index ? loading : false}
        />
        <Button
          className="w-full"
          type="button"
          onClick={() => handleDelete(index, field._id)}
          disabled={!isEditor}
          buttonText="Delete"
        />
      </div>
    </form>
  )
}

export default AreaRow
